import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Link } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import i18n from 'i18next';
import publicEngagementData from '../data/PublicEngagementData.json';


const PublicInput = () => {
  const { t, i18n: i18nInstance } = useTranslation();
  const language = i18nInstance.language;

  //const publicCommentsUrl = 'https://gis.exp.com/miami_lakes_public_comments/'; 

  const publicCommentsUrl =
  i18n.language === 'es'
    ? 'https://gis.exp.com/miami_lakes_public_comments-es/?locale=es-mx'
    : 'https://gis.exp.com/miami_lakes_public_comments/';


  return (
    <Box>
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          maxWidth: '100%',
          width: '100%',
          px: 2,
          py: 3,
          boxSizing: 'border-box',
          bgcolor: '#808681ff',
        }}
      >
        <Typography variant="h3" sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
          {t('public_input.events_title', 'Events')}
        </Typography>
      </Box>

      <Box
        sx={{
          position: 'relative',
          width: '100%',
          minHeight: 'auto',
          py: { xs: 4, md: 6 },
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          maxWidth: '100vw',
        }}
      >
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/public-input-event.jpg`}
          alt="Resources background"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectPosition: 'top center',
            objectFit: 'cover',
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1,
          }}
        />

        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            color: 'white',
            width: '100%',
            px: 2,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
          }}
        >
          {publicEngagementData.map((item) => {
            const title = language === 'es' ? item.title_es : item.title_en;
            return (
              <Link
                key={item.id}
                component={RouterLink}
                to={`/public-engagement/${item.slug}`}
                sx={{
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  color: 'white',
                  textDecoration: 'underline',
                  fontWeight: 500,
                }}
              >
                {title}
              </Link>
            );
          })}
        </Box>
      </Box>
      {/* Intro section */}
      <Box component="main" sx={{ p: 4, textAlign: 'center' }}>
        <Typography
          variant="h3"
          sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mt: -2, mb: 4 }}
        >
          {t('public_input.title')}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: '75%',
            mx: 'auto',
            textAlign: 'justify',
            fontSize: { xs: '1rem', sm: '1.25rem' },
            lineHeight: 1.6,
            mb: 4,
          }}
        >
          {t('public_input.description')}
        </Typography>

        {/* Embedded website */}
        <Box
          sx={{
            width: '100%',
            maxWidth: '90%',
            height: '700px',
            mx: 'auto',
            mb: 4,
            border: '1px solid #ccc',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <iframe
            src={publicCommentsUrl}
            title="Embedded Website"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        </Box>


      </Box>

      {/* Survey Section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          width: '100%',
          height: { xs: 'auto', md: '400px' },
          overflowX: 'hidden',
        }}
      >
        {/* Left Column */}
        <Box
          sx={{
            width: { xs: '100%', md: '50%' },
            boxSizing: 'border-box',
            bgcolor: '#33834a',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: '100%',
              px: { xs: 2, sm: 4 },
              py: 4,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: 2,
              boxSizing: 'border-box',
              maxWidth: '100%',
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: '2rem', md: '2.5rem' },
                mt: -2,
                mb: 4,
              }}
            >
              {t('public_input.survey_title', 'Community Survey')}
            </Typography>
      
            <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
              {t('public_input.survey_text')}
            </Typography>
      
            <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
              <Button
                variant="contained"
                onClick={() => window.open('https://survey123.arcgis.com/share/b20f86078b9b497791c9e1c00223cbac', '_blank')}
                sx={{
                  backgroundColor: 'black',
                  color: 'white',
                  '&:hover': { backgroundColor: '#333' },
                }}
              >
                {t('public_input.take_survey_button', 'Take the Survey')}
              </Button>
            </Box>
          </Box>
        </Box>
      
        {/* Right Column (Image) */}
{/* Right Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/public-input-survey.jpg`}
    alt={t('public_input.survey_image_alt', 'People taking action')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>

      </Box>

      {/* Social media Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: 'auto',
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '400px', md: '5' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/public-input-social-media.jpg`}
    alt={t('public_input.social_media_image_alt', 'social_media_img')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity to taste
    }}
  />
</Box>


  {/* Right Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      bgcolor: '#00b9c4',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('public_input.social_media_title', 'Check our social media to stay up to date:')}
      </Typography>

<Box sx={{ display: 'flex', justifyContent: 'center', gap: 5 }}>
  <Link href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
    <FacebookIcon sx={{ fontSize: { xs: 40, sm: 65 }, color: 'blue' }} />
  </Link>
  <Link href="https://www.instagram.com/miamilakesvisionzero" target="_blank" rel="noopener noreferrer">
    <InstagramIcon sx={{ fontSize: { xs: 40, sm: 65 }, color: '#C13584' }} />
  </Link>
  <Link href="https://twitter.com/miamilakesvz" target="_blank" rel="noopener noreferrer">
    <XIcon sx={{ fontSize: { xs: 40, sm: 60 }, color: 'black' }} />
  </Link>
</Box>

    </Box>
  </Box>
</Box>





    </Box>
  );
};

export default PublicInput;
